import { useNotificationsCount } from '@tribeplatform/react-sdk/hooks'
import { IndicatorBadge } from '@tribeplatform/react-ui-kit/IndicatorBadge'

export const NotificationIndicatorBadge = ({ children, ...rest }) => {
  const { data: notificationCount } = useNotificationsCount({
    useQueryOptions: {
      refetchInterval: 120000,
    },
  })

  return (
    <IndicatorBadge count={notificationCount || 0} {...rest}>
      {children}
    </IndicatorBadge>
  )
}
